<div fxLayout="column">
  <div fxFlex="100" fxLayout="row">
    <div fxFlex="50">
      <mat-card>
        <mat-card-content>
          <div fxLayout.lt-md="column wrap" fxLayout="row wrap" fxLayoutAlign="space-around center">
            <div class="font-weight-600" fxFlex="10">Status</div>
            <div fxFlex="90" fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="2%">
              <button (click)="onFilterClick('all')"
                      [ngClass]="filterConditions === 'all' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                All ({{ queues?.allStatus }})
              </button>
              <button (click)="onFilterClick('new')"
                      [ngClass]="filterConditions === 'new' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                New ({{ queues?.newStatus }})
              </button>
              <button (click)="onFilterClick('under review')"
                      [ngClass]="filterConditions === 'under review' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                Under Review ({{ queues?.underReviewStatus }})
              </button>
              <button (click)="onFilterClick('complete')"
                      [ngClass]="filterConditions === 'complete' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                Complete ({{ queues?.completeStatus }})
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div fxFlex="50">
      <mat-card>
        <mat-card-content>
          <div fxLayout.lt-md="column wrap" fxLayout="row wrap" fxLayoutAlign="space-around center">
            <div class="font-weight-600" fxFlex="10">Assigned For</div>
            <div fxFlex="90" fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="2%">
              <button (click)="onFilterClick('account update')"
                      [ngClass]="filterConditions === 'account update' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                Account Update({{ queues?.accountUpdateStatus }})
              </button>
              <button (click)="onFilterClick('customer followup')"
                      [ngClass]="filterConditions === 'customer followup' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                Customer followup({{ queues?.customerfollowupStatus }})
              </button>
              <button (click)="onFilterClick('insurance followup')"
                      [ngClass]="filterConditions === 'insurance followup' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                Insurance followup ({{ queues?.insurancefollowupStatus }})
              </button>
              <button (click)="onFilterClick('investigation')"
                      [ngClass]="filterConditions === 'investigation' ? 'theme-button' : 'plain-button'"
                      mat-raised-button>
                Investigation({{ queues?.investigationStatus }})
              </button>



            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="teranet-padding-relative" fxFlex="100">
    <ngx-spinner [fullScreen]="false"
                 type="ball-clip-rotate-multiple"
                 bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"></ngx-spinner>
    <Teranet-CustomizedGrid [data]="LenderRemediationModel"
                            [featureComponentGridSettings]="featureComponentGridSettings"
                            [gridName]="queueName"
                            [gridSettings]="gridSettings"
                            [isComplete]="true"
                            [isReject]="true"
                            [initialGridSettings]="intialGridSettings"
                            [isFinishLoading]="isFinishLoading"
                            [pageName]="'workqueue'"
                            [assignedStatusId]="assignedStatusId"
                            [workqueueStatusId]="workqueueStatusId"
                            [queue]="'LenderRemediation'"></Teranet-CustomizedGrid>
  </div>
</div>
